import settings from '../libs/config';

const loggingEnabled = () => {
	if (settings.loggingEnabled === true) {
		return true;
	}
	return false;
};

// Based on http://stackoverflow.com/questions/13815640/a-proper-wrapper-for-console-log-with-correct-line-number

const Logger = {};
const noopFn = function () { };
const errorFn = function () { console.error("Pilotly error."); };

['log', 'debug', 'info', 'warn'].forEach((level) => {
	Logger[level] = loggingEnabled() ? window.console[level] : noopFn;
});
['error'].forEach((level) => {
	Logger[level] = loggingEnabled() ? window.console[level] : errorFn;
});

export default Logger;


// WEBPACK FOOTER //
// ./src/functions/logging.js